import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Edit from './Edit';
import History from './History';
import Investors from './Investors';
import Overview from './Overview';
import Transactions from './Transactions';
import Reservations from './Reservations';

export default function router(): JSX.Element {
    return (
        <Switch>
            <Route exact={true} path='/investments/:uuid' component={Overview} />
            <Route exact={true} path='/investments/:uuid/edit' component={Edit} />
            <Route exact={true} path='/investments/:uuid/history' component={History} />
            <Route exact={true} path='/investments/:investmentUuid/investors' component={Investors} />
            <Route exact={true} path='/investments/:investmentUuid/reservations' component={Reservations} />
            <Route exact={true} path='/investments/:investmentUuid/transactions' component={Transactions} />
        </Switch>
    );
}
